import { Button, FlipCard } from '@components'
import React from 'react'
import styled from 'styled-components'
import holviIcon from '@assets/holvi-icon-light.svg'
import ReactMarkdown from 'react-markdown'
import { FaTicket } from 'react-icons/fa6'
import { useTranslation } from 'react-i18next'
import { useBusinessContext } from '@root/context'

export const HolviPromoCard: React.FC = () => {
  const { t } = useTranslation()
  const { slug } = useBusinessContext()

  return (
    <FlipCard
      enableFlipping={false}
      maxPerspectiveRotation={5}
      renderFront={() => (
        <StyledPromoCard>
          <IconWrapper>
            <img src={holviIcon} />
          </IconWrapper>

          <h2>{t(`containers.holviPromoCard.title`)}</h2>
          <ReactMarkdown>{t(`containers.holviPromoCard.description`)}</ReactMarkdown>

          <a href={`/${slug}/business-accounts`} target="_blank" rel="noreferrer">
            <RendeemButton type="button" icon={<FaTicket />}>
              {t(`containers.holviPromoCard.cta`)}
            </RendeemButton>
          </a>
        </StyledPromoCard>
      )}
    />
  )
}

const StyledPromoCard = styled.div`
  margin-top: ${({ theme }) => theme.spacing.sm}rem;
  margin-bottom: ${({ theme }) => theme.spacing.lg}rem;
  padding: ${({ theme }) => theme.spacing.lg}rem;
  background: ${({ theme }) => theme.colors.menuBg};
  border: 1px solid ${({ theme }) => theme.colors.dashboardExtra2};
  border-radius: ${({ theme }) => theme.borderRadius.md}rem;
  color: ${({ theme }) => theme.colors.neutralWhite};
  font-size: ${({ theme }) => theme.fontSize.md}rem;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md}rem;
  width: 100%;
  overflow: hidden;

  h2 {
    font-size: ${({ theme }) => theme.fontSize.md}rem;
  }

  h2,
  p {
    z-index: 10;
  }

  & > * {
    margin: 0;
  }
`

const RendeemButton = styled(Button).attrs({ size: 'sm' })`
  font-weight: bold;
  width: fit-content;
  color: ${({ theme }) => theme.colors.neutralWhite} !important;
  background: ${({ theme }) => theme.colors.primary} !important;
`

const IconWrapper = styled.div`
  z-index: 10;
  pointer-events: none;
  right: 0;
  bottom: 0;
  transform: translate(50%, 50%);
  width: 120%;
  height: 120%;

  // Rotating animation
  animation: rotate 20s linear infinite;

  @keyframes rotate {
    0% {
      transform: translate(35%, 55%) rotate(0deg);
    }
    100% {
      transform: translate(35%, 55%) rotate(360deg);
    }
  }

  & > * {
    user-select: none;
    position: absolute;
    opacity: 0.1;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
`
